Object.defineProperty(exports, "__esModule", { value: true });
exports.getEncodedImgUrl = exports.encodeSvg = exports.isNullOrUndefined = exports.getEarlyNotificationTime = void 0;
function getEarlyNotificationTime() {
    var earlierTime = new Date();
    earlierTime.setHours(earlierTime.getHours() - 12);
    return earlierTime;
}
exports.getEarlyNotificationTime = getEarlyNotificationTime;
function isNullOrUndefined(obj) {
    return obj === null || obj === undefined;
}
exports.isNullOrUndefined = isNullOrUndefined;
var svgDataUriRegExp = /^data\:image\/svg\+xml/;
function encodeSvg(svg) {
    return svgDataUriRegExp.test(svg) ? svg : "data:image/svg+xml," + encodeURIComponent(svg);
}
exports.encodeSvg = encodeSvg;
var b64Prefix = 'data:image/svg+xml;base64,';
function getEncodedImgUrl(b64String) {
    return b64Prefix + b64String;
}
exports.getEncodedImgUrl = getEncodedImgUrl;
//# sourceMappingURL=notificationHelper.js.map